<div class="container-fluid" *ngIf="showPopUp">
  <div class="row col-12" *ngIf="saving">
    <div class="alert alert-info m-md col-12">
      <span>
        <i class="fas fa-spinner fa-2x loading-spin m-r-md" aria-hidden="true"></i><span>
          {{ loadingMessage }}</span>
      </span>
    </div>
  </div>
  <div class="row m-t-md" *ngIf="showPopUp&&!saving">
    <div class="col-12">
      <!-- INFORMACIÓN DE ERROR de VALIDACION -->
      <div *ngIf="!isUpdateOk() && !isAltaOk()">
        <div class="alert alert-info">
          <span [innerHTML]="message"></span>
        </div>
        <!-- <ng-container *ngIf="errors"> -->
        <div *ngIf="errorDto" class="alert alert-danger">
          <span class="text-danger" *ngIf="errorDto.message"> {{ errorDto.message }} </span>
          <!-- <ng-template>  class="plyca-error-list"-->
          <ul>
            <li *ngFor="let error of errorDto.errors" class="text-danger">
              {{ error.message }}
            </li>
          </ul>
          <!-- </ng-template> -->
        </div>
        <!-- <ng-template #errorElse>
          <div *ngIf="errors.required ">
            {{'Forms.error.required' | translate}}
          </div>
          <div *ngIf="errors.minlength ">
            {{'Forms.error.minlength' | translate}}
          </div>
          <div *ngIf="errors.minlength ">
            {{'Forms.error.minlength' | translate}}
          </div>
        </ng-template> -->
        <!-- </ng-template> -->
      </div>
      <!-- SOLAMENTE MOSTRAMOS LA INFORMACION DE SI ES POSIBLE INICIAR TRAMITACION EN EL ULTIMO PASO-->
      <div class="alert alert-info" *ngIf="
          (isUpdateOk() || isAltaOk()) && lastStep && !isProjectStartEnabled()
        ">
        <span [innerHTML]="this.translate.instant('GenericDossier.start.nok')"></span>
      </div>
      <div class="alert alert-info" *ngIf="isProjectStartEnabled() && isFormIdPropPlan()">
        <span class="col-12">
          <i class="fas fa-info fa-2x m-r-md" aria-hidden="true"></i>
          <span [innerHTML]="this.translate.instant('GenericDossier.start.ok_PropPlan')"></span></span>
      </div>
      <div class="alert alert-info" *ngIf="isProjectStartEnabled() && !isFormIdPropPlan()">
        <span class="col-12">
          <i class="fas fa-info fa-2x m-r-md" aria-hidden="true"></i>
          <span [innerHTML]="this.translate.instant('GenericDossier.start.ok')"></span></span>
      </div>

    </div>
  </div>
  <div class="row m-t-md m-b-md" *ngIf="showPopUp&&!saving ">
    <div class="col-12">
      <button class="btn btn-md  btn-secondary float-left" (click)="close()">
        <i class="fas fa-times"></i> {{ 'General.close' | translate }}
      </button>

      <button class="btn btn-md btn-primary float-right" *ngIf="isProjectStartEnabled() && isFormIdPropPlan()"
        (click)="initTram()" [disabled]="!isLoaded()">
        <i class="fa fa-save"></i> {{ 'GenericDossier.start.accept' | translate }}
      </button>

      <button class="btn btn-md btn-primary float-right" *ngIf="isProjectStartEnabled() && !isFormIdPropPlan()"
        (click)="initTram()" [disabled]="!isLoaded()">
        <i class="fa fa-save"></i> {{ 'GenericDossier.start.ok' | translate }}
      </button>
    </div>
  </div>
</div>